(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ConfirmationManagementZoneController = (function(superClass) {
    var alphabeticalComparison;

    extend(ConfirmationManagementZoneController, superClass);

    function ConfirmationManagementZoneController(scope, transitions, state, generate, data1, loader, window) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.generate = generate;
      this.data = data1;
      this.loader = loader;
      this.window = window;
      this.getSeedCompaniesByCrop = bind(this.getSeedCompaniesByCrop, this);
      this.filterGroupBy = bind(this.filterGroupBy, this);
      this.autoloadDropdown = bind(this.autoloadDropdown, this);
      this.setPlaceholderText = bind(this.setPlaceholderText, this);
      this.checkStatus = bind(this.checkStatus, this);
      this.socketUpdateVps = bind(this.socketUpdateVps, this);
      this.close = bind(this.close, this);
      this.updateTab = bind(this.updateTab, this);
      this.confirm = bind(this.confirm, this);
      this.resetShapefileDropdowns = bind(this.resetShapefileDropdowns, this);
      this.updateMapPartialRow = bind(this.updateMapPartialRow, this);
      this.getShapefileColumnValues = bind(this.getShapefileColumnValues, this);
      this.validateGroupBy = bind(this.validateGroupBy, this);
      this.validateBasicSelections = bind(this.validateBasicSelections, this);
      this.validateStatus = bind(this.validateStatus, this);
      this.validate = bind(this.validate, this);
      this.loadRowData = bind(this.loadRowData, this);
      this.paginate = bind(this.paginate, this);
      this.loadSelectData = bind(this.loadSelectData, this);
      this.conversionRequestSent = bind(this.conversionRequestSent, this);
      ConfirmationManagementZoneController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.resize = 0;
      this.loadSelectData();
      this.scope.alphabeticalComparison = this.alphabeticalComparison;
      this.scope.getShapefileCategories = this.getShapefileCategories;
      this.scope.getShapefileAttributes = this.getShapefileAttributes;
      this.scope.getShapefileColumnValues = this.getShapefileColumnValues;
      this.scope.updateMapPartialRow = this.updateMapPartialRow;
      this.scope.resetShapefileDropdowns = this.resetShapefileDropdowns;
      this.scope.confirm = this.confirm;
      this.scope.close = this.close;
      this.scope.socketUpdateVps = this.socketUpdateVps;
      this.scope.checkStatus = this.checkStatus;
      this.scope.setPlaceholderText = this.setPlaceholderText;
      this.scope.filterGroupBy = this.filterGroupBy;
      this.scope.autoloadDropdown = this.autoloadDropdown;
      this.scope.resizeTable = (function(_this) {
        return function() {
          return _this.scope.resize++;
        };
      })(this);
      this.window.conversionRequestSent = this.conversionRequestSent;
      this.scope.paginate = this.paginate;
    }

    ConfirmationManagementZoneController.prototype.conversionRequestSent = function(data) {
      return this.scope.$emit('uploads:processing');
    };

    alphabeticalComparison = function(a, b) {
      var result;
      if (a.data.status === 'Reconfirm') {
        return -1;
      }
      if (b.data.status === 'Reconfirm') {
        return 1;
      }
      result = strnatcasecmp(a.data.status, b.data.status);
      if (result === 0) {
        result = strnatcasecmp(a.data.reference.farmName, b.data.reference.farmName);
      }
      if (result === 0) {
        result = strnatcasecmp(a.data.reference.fieldName, b.data.reference.fieldName);
      }
      if (result === 0) {
        result = strnatcasecmp(a.data.selected.year, b.data.selected.year);
      }
      return result;
    };

    ConfirmationManagementZoneController.prototype.loadSelectData = function() {
      this.data.getAllYears().then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope.years = response.data.data;
          }
        };
      })(this));
      this.data.getCrops().then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope.crops = response.data.data;
          }
        };
      })(this));
      return this.data.getShapefileCategories().then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope.categories = response.data.data;
          }
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.paginate = function(table_state, cnt) {
      this.cnt = cnt;
      if (this.reload) {
        this.reload = false;
        table_state.pagination.start = 0;
        table_state.pagination.number = 25;
      }
      return this.loadRowData(table_state.pagination.start || 0, table_state.pagination.number || 25).then((function(_this) {
        return function(result) {
          table_state.pagination.totalItemCount = result;
          return table_state.pagination.numberOfPages = Math.ceil(result / table_state.pagination.number);
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          return _this.setAlert({
            msg: 'Error loading data',
            type: 'error'
          });
        };
      })(this))["finally"]((function(_this) {
        return function() {
          _this.scope.resize++;
          _this.loader.hideAll();
          return true;
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.loadRowData = function(skip, take) {
      if (skip == null) {
        skip = 0;
      }
      if (take == null) {
        take = 10;
      }
      this.loader.overMap('Loading...');
      return this.data.getManagementZoneRows(skip, take).then((function(_this) {
        return function(response) {
          var j, len, ref, ref1, ref2, row;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            _this.scope.rows = response.data.data.rows;
            _this.data.setRows(_this.scope.rows);
            ref2 = _this.scope.rows;
            for (j = 0, len = ref2.length; j < len; j++) {
              row = ref2[j];
              if (row.preloaded != null) {
                row.selected = row.preloaded;
              } else {
                row.selected = {};
              }
              row.disabled = {
                confirm: false
              };
              _this.validate(row);
            }
            return response.data.data.count;
          }
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.validate = function(row) {
      row.disabled.confirm = false;
      if (!this.validateBasicSelections(row.selected) || !this.validateGroupBy(row.selected) || !this.validateStatus(row)) {
        return row.disabled.confirm = true;
      }
    };

    ConfirmationManagementZoneController.prototype.validateStatus = function(row) {
      var ref;
      return (ref = row.end.status) === 'Confirm' || ref === 'Reconfirm';
    };

    ConfirmationManagementZoneController.prototype.validateBasicSelections = function(selected) {
      var ref;
      return selected.year && ((ref = selected.category) != null ? ref.id : void 0) && selected.group_by;
    };

    ConfirmationManagementZoneController.prototype.validateGroupBy = function(selected) {
      var ref, ref1, ref2;
      if (!((ref = selected.category) != null ? ref.name : void 0)) {
        return false;
      } else if (((ref1 = selected.category) != null ? ref1.name : void 0) === 'Irrigation') {
        if (!selected.dryland_value) {
          return false;
        }
      } else if (((ref2 = selected.category) != null ? ref2.name : void 0) === 'Productivity') {
        if (!selected.mmz_crop) {
          return false;
        }
      }
      return true;
    };

    ConfirmationManagementZoneController.prototype.getShapefileColumnValues = function(row) {
      row.fetching = true;
      return this.data.getShapefileColumnValues(row).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) === 'success') {
            row.required.dryland_values = response.data.data;
            _this.autoloadDropdown(row, 'dryland_values', 'dryland_value');
            return row.fetching = false;
          }
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.updateMapPartialRow = function(row) {
      return this.data.saveMapPartialSelections(row).then((function(_this) {
        return function(response) {
          var jsr, ref, ref1;
          jsr = response.data.data;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            row.end.status = jsr.status != null ? jsr.status : row.end.status;
            row.can_confirm = response.data.data.can_confirm;
            return _this.validate(row);
          }
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.resetShapefileDropdowns = function(row, specific) {
      if (specific == null) {
        specific = null;
      }
      if (specific === 'dryland') {
        return row.selected.dryland_value = null;
      }
      if (!specific) {
        row.selected.group_by = null;
        row.selected.mmz_crop = null;
        row.selected.dryland_value = null;
        this.setPlaceholderText(row);
      }
      return this.validate(row);
    };

    ConfirmationManagementZoneController.prototype.confirm = function(row) {
      var is_shapefile, update_array;
      update_array = [];
      is_shapefile = row.reference.map_partials_id != null;
      if (is_shapefile) {
        update_array.push({
          id: row.reference.map_partials_id,
          fields_id: row.reference.field_id,
          year: row.selected.year,
          category: row.selected.category,
          group_by: row.selected.group_by,
          crop: row.selected.mmz_crop,
          dryland_value: row.selected.dryland_value
        });
      }
      row.can_confirm = false;
      row.end.status = 'Processing';
      return this.generate.updateRow(update_array, is_shapefile, this.scope.tab).then((function(_this) {
        return function(response) {
          var status;
          status = response.data.data;
          if (status === 'Processing') {
            row.end.status = status;
          }
          if (status === 'Processed') {
            return row.end.status = 'Done';
          }
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.updateTab = function() {
      var j, len, ref, ref1, row, unconfirmed;
      unconfirmed = 0;
      ref = this.scope.rows;
      for (j = 0, len = ref.length; j < len; j++) {
        row = ref[j];
        if ((ref1 = row.end.status) === 'Confirm' || ref1 === 'Reconfirm') {
          unconfirmed += 1;
        }
      }
      return this.scope.tabs.mmz.unconfirmed = unconfirmed;
    };

    ConfirmationManagementZoneController.prototype.close = function() {
      return this.state.go('data.add.upload');
    };

    ConfirmationManagementZoneController.prototype.socketUpdateVps = function(data) {
      var child, children, done, failed, i, j, k, len, len1, ref, ref1, ref2, ref3, row, status, vps_id;
      children = [];
      for (vps_id in data) {
        status = data[vps_id];
        children.push(vps_id);
        ref = this.scope.rows;
        for (j = 0, len = ref.length; j < len; j++) {
          row = ref[j];
          ref1 = row.children;
          for (i in ref1) {
            child = ref1[i];
            if (child.end.id === Number(vps_id)) {
              child.end.status = status;
            }
          }
        }
      }
      ref2 = this.scope.rows;
      for (k = 0, len1 = ref2.length; k < len1; k++) {
        row = ref2[k];
        done = true;
        ref3 = row.children;
        for (i in ref3) {
          child = ref3[i];
          failed = child.end.status === 'Failed';
          if (child.end.status !== 'Processed') {
            done = false;
          }
        }
        if (done) {
          row.end.status = 'Done';
        }
        if (failed) {
          row.end.status = 'Failed';
        }
      }
      return _.defer((function(_this) {
        return function() {
          return _this.scope.$apply();
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.checkStatus = function(row) {
      var i, map, property, reconfirm, ref, ref1, ref2, ref3, ref4, value;
      ref = row.selected;
      for (i in ref) {
        value = ref[i];
        if (value === null || value === void 0) {
          if (row.selected.number_of_products === 2) {
            row.can_confirm = true;
          } else {
            row.can_confirm = false;
          }
        } else {
          row.can_confirm = true;
        }
      }
      if (row.confirmed_data !== false) {
        reconfirm = false;
        map = {
          crops_id: (ref1 = row.selected.crop) != null ? ref1.id : void 0,
          seed_companies_id: (ref2 = row.selected.seed_company) != null ? ref2.id : void 0,
          hybrids_id: (ref3 = row.selected.product) != null ? ref3.id : void 0,
          year: parseInt(row.selected.year)
        };
        ref4 = row.confirmed_data;
        for (property in ref4) {
          value = ref4[property];
          if (map[property] !== value) {
            reconfirm = true;
          }
        }
        if (reconfirm === true) {
          return row.end.status = 'Reconfirm';
        } else {
          row.can_confirm = false;
          return row.end.status = 'Done';
        }
      }
    };

    ConfirmationManagementZoneController.prototype.setPlaceholderText = function(row) {
      if (!row.selected.category) {
        return 'Select...';
      }
      switch (row.selected.category.name) {
        case 'Productivity':
          return 'Select Yield Label...';
        case 'Irrigation':
          return 'Select Irrigation Label...';
      }
    };

    ConfirmationManagementZoneController.prototype.autoloadDropdown = function(row, options, property) {
      if (row.required[options].length === 1) {
        row.selected[property] = row.required[options][0];
      }
      return this.updateMapPartialRow(row);
    };

    ConfirmationManagementZoneController.prototype.filterGroupBy = function(row) {
      row.fetching = true;
      return this.data.getShapefileAttributes(row).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (((ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) === 'success') {
            if (response.data.data.length === 0) {
              row.selected.group_by = 'No valid attributes found';
              row.invalid = true;
              $("#row" + row.reference.map_partials_id).addClass('category-error');
            } else {
              row.required.group_by = response.data.data;
              _this.autoloadDropdown(row, 'group_by', 'group_by');
              row.invalid = false;
              row.fetching = false;
            }
            return _this.updateMapPartialRow(row);
          }
        };
      })(this));
    };

    ConfirmationManagementZoneController.prototype.getSeedCompaniesByCrop = function(product, crop, reset) {
      if (reset == null) {
        reset = true;
      }
      if (reset) {
        product.selected.seedCompany = null;
        product.selected.product = null;
      }
      return this.generate.getSeedCompaniesByCrop(crop.id).then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return product.required.seedCompanies = response.data.data;
          }
        };
      })(this));
    };

    return ConfirmationManagementZoneController;

  })(Controller);

}).call(this);
